// Importing all site images
import homebg from "../../assets/homebg.jpg";
import vs_img from "../../assets/VSProfile.png";
import vs_img_2 from "../../assets/vsnake.png";
import dots_img from "../../assets/dots.jpg";
import quiet_img from "../../assets/quiet.png";
import d_dog from "../../assets/d-dog.png";
import d_horse from "../../assets/d-horse.png";
import d_walker from "../../assets/d-walker.png";
import pequod from "../../assets/pequod.png";

// Exporting object with all site images to be used elsewhere
export const images = {
  homebg,
  vs_img,
  vs_img_2,
  dots_img,
  quiet_img,
  d_dog,
  d_horse,
  d_walker,
  pequod,
};
